import { DefaultActionType, EmbeddedAction } from 'modules/graphql';
import styled from 'styled-components';
import { body1, colors, spacing } from 'ui/theme';
import { DISPLAY_CONTENT, EmbeddedActionButton, EmbeddedOpenAction } from './constants';
import { GqlUpsertTemplateInvalidContentFailureTypes, ValidationError } from '../common';

export const ReadOnlyField = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};

  ${body1}
  cursor: default;
`;

const EmptyInputText = styled.span`
  color: ${colors.textSecondary};
`;

export const EmptyInput = () => {
  return <EmptyInputText>{DISPLAY_CONTENT.settings.emptyInputText}</EmptyInputText>;
};

export const getCharacterCountText = (content: string, maxLength?: number) =>
  `${content.length}${maxLength ? `/${maxLength}` : ''} characters`;

export const formatLabelForId = (label: string) => label.trim().toLowerCase().split(' ').join('-');

export const generateRandomString = (length = 6) => Math.random().toString(20).substring(2, length);

export const getOpenActionType = (action: DefaultActionType | undefined) => {
  if (!action) {
    return EmbeddedOpenAction.NONE;
  } else if (action.type === EmbeddedOpenAction.URL) {
    return EmbeddedOpenAction.URL;
  } else {
    return EmbeddedOpenAction.CUSTOM;
  }
};

export const getButtonActionType = (action: EmbeddedAction | undefined) =>
  action?.type !== EmbeddedActionButton.CLOSE && action?.type !== EmbeddedActionButton.URL
    ? EmbeddedActionButton.CUSTOM
    : action.type;

export const getInvalidButtonActionsFromContentErrors = (errors: ValidationError[]) =>
  errors.reduce(
    (acc: EmbeddedAction[], { __typename, invalidButtonActions }) =>
      __typename === GqlUpsertTemplateInvalidContentFailureTypes.INVALID_ACTION_BUTTON_URI &&
      invalidButtonActions
        ? [...acc, ...invalidButtonActions]
        : acc,
    [],
  );
